var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle206(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "401.02396398844206 81.76704602414664 23.5862443448911 24.997540001742706",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M410.72,85.77c.3.06.89.08,1.4.3,3.82,1.66,6.76,4.27,8.14,8.27.41,1.18.46,2.67.15,3.89-1.02,4.12-5.54,5.86-8.99,3.41-3.39-2.41-5.29-5.99-6.27-9.92-.77-3.08,2.1-6.06,5.56-5.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle206);
export default __webpack_public_path__ + "static/media/twinkle-2-06.d6d09c268663034574bd69eb7d76f238.svg";
export { ForwardRef as ReactComponent };